<template>
    <div class="layout-museum">
        <div class="uk-inline inline-hero uk-visible@m">
            <img :src="page.heroImage.large" :alt="page.title" >

            <div class="uk-position-cover hero-overlay uk-background-blend-multiply uk-light">
                <div class="uk-position-bottom uk-margin-large-bottom">
                    <div class="uk-container uk-container-small uk-text-center">
                        <router-link :to="parent.link" v-if="parent"><label>{{parent.menuTitle}}</label></router-link>
                        <h1 class="uk-margin-small-top">{{page.title}}</h1>

                        <slot name="summary">
                            <p class="uk-text-lead text-white" v-if="page.subtitle">{{page.subtitle}}</p>
                        </slot>

                        <slot name="subheader"></slot>
                    </div>
                </div>
            </div>
        </div>

        <div class="uk-hidden@m uk-section uk-section-xlarge uk-background-legible uk-background-cover uk-background-blend-multiply hero" v-bind:style="{ backgroundImage: `url(${page.heroImage.large4x3})`}" v-if="page?.heroImage?.id > 0">
            <div class="uk-container uk-container-small uk-light uk-text-center">

                    <router-link :to="parent.link" v-if="parent"><label>{{parent.menuTitle}}</label></router-link>
                    <h1 class="uk-margin-small-top">{{page.title}}</h1>

                    <slot name="summary">
                        <p class="uk-text-lead" v-if="page.subtitle">{{page.subtitle}}</p>
                    </slot>

                    <slot name="subheader"></slot>

            </div>
        </div>

        <div class="uk-background-darkest uk-light">
            <div class="uk-flex uk-grid-collapse" uk-grid>
                <div class="uk-width-1-2@m uk-width-1-1@s">
                    <div class="flex-video widescreen">
                        <iframe width="560" height="315" src="https://www.youtube.com/embed/jCGnssI2eWk" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>
                    </div>
                </div>
                <div class="uk-width-1-2@m uk-width-1-1@s">
                    <div class="uk-tile uk-padding-large">
                        <!-- <div class="uk-align-center"> -->
                            <p v-html="page.summary" />
                        <!-- </div> -->
                    </div>
                </div>
            </div>
        </div>

        <FloatingBadge text="An Educational Experience for Students of All Ages" badgeClass="background-green"/>

        <div class="uk-section uk-section-medium uk-background-white" v-if="page.content">
            <div class="uk-container uk-container-small">
                <div class="content" v-html="page.content"></div>
            </div>
        </div>

        <div class="uk-section uk-section background-blue uk-text-center uk-light">

            <label class="text-green">Visiting Hours</label>
            <div class="uk-flex uk-flex-center" uk-grid>
                <div>
                    <h3 class="uk-margin-small-top">Monday - Friday: <b>10am to 5pm</b></h3>
                </div>
                <div>
                    <h3 class="uk-margin-small-top">Saturdays: <b>10am to 4pm</b></h3>
                </div>
                <div>
                    <h3 class="uk-margin-small-top">Sundays: <b>Closed</b></h3>
                </div>
            </div>

        </div>

        <div class="uk-background-darkest uk-light">
            <div class="uk-flex uk-grid-collapse" uk-grid>
                <div class="uk-width-1-2@m uk-width-1-1@s">
                    <div class="flex-video widescreen">
                        <iframe style="height:100%;width:100%;border:0;" frameborder="0" src="https://www.google.com/maps/embed/v1/place?q=Lowell+Milken+Center+for+Unsung+Heroes+1+South+Main+Fort+Scott,+KS+66701&key=AIzaSyBFw0Qbyq9zTFTd-tUY6dZWTgaQzuU17R8"></iframe>
                    </div>
                </div>
                <div class="uk-width-1-2@m uk-width-1-1@s">
                    <div class="uk-tile uk-padding-large uk-text-center uk-text-left@m">
                        <h4><b>Lowell Milken Center</b><br/><em>for Unsung Heroes</em></h4>
                        <p>
                            <b>P:</b> <a href="tel:6202231312">620-223-1312</a><br/>
                            <b>E:</b> <a href="mailto:info@lowellmilkencenter.org">info@lowellmilkencenter.org</a>
                        </p>
                        <p>Lowell Milken Center for Unsung Heroes<br/>
                            1 South Main<br/>
                            Fort Scott, KS 66701
                        </p>
                    </div>
                </div>
            </div>
        </div>

        <Testimonials :testimonials="(page && page.testimonialsArray) ? JSON.parse(page.testimonialsArray, true) : false" photos="true" />

    </div>
</template>

<script>
export default {
    inject: [ 'api', 'theme' ],
    props: ['page', 'parent']
}
</script>
